import React, { Component, ReactElement } from 'react';
import { TextField, Grid } from '@material-ui/core'

type Currency = 'AU$' | 'US$'

type Props = {
    value: number,
    onChange: (value: number, currency: Currency, invalid: boolean) => void,
    onLoad: (invalid: boolean) => void,
    currencies: Currency[],
    defaultCurrency?: Currency,
    startAdornment?: ReactElement,
    endAdornment?: ReactElement,
    disabled?: boolean,
    width?: string,
    label?: string,
    lowerThan? : number,
}

type State = {
    currentCurrency: Currency,
    value: string | number,
    error: boolean,
}

class PriceInput extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        let newVal = Math.round(this.props.value * 100) / 100

        this.state = {
            currentCurrency: this.props.defaultCurrency || this.props.currencies[0],
            value: newVal,
            error: newVal === 0
        }

        this.internalOnChange = this.internalOnChange.bind(this)
    }

    internalOnChange(value: string | number, currency: Currency) {
        this.setState({value})
    }

    componentDidMount(){
        this.props.onLoad( this.state.error)
    }

    componentDidUpdate(prevProps: Props){
        if(this.props.value !== prevProps.value){
            let newVal = Math.round(this.props.value * 100) / 100
            this.setState({value: newVal, error: newVal === 0 })
        }
    }

    

    render() {
        return (
            <Grid container alignItems="center" alignContent="center" style={{ textAlign: "center" }}>
                <Grid item xs={12} sm={12}>
                    <TextField
                        error={this.state.error}
                        style={{width: this.props.width || "100%"}}
                        disabled={this.props.disabled === undefined ? false : this.props.disabled }
                        label={this.props.label || ""}
                        inputProps={{ style: { textAlign: 'center' } }} inputMode="numeric"
                        onBlur={()=>{
                            let newVal = parseFloat(this.state.value.toString())
                            let isInvalid = newVal === 0
                            this.setState({error: isInvalid})
                            this.props.onChange(newVal, this.state.currentCurrency, isInvalid)
                        }}
                        onChange={(e) => {
                            if (e.target.value === '')
                                this.internalOnChange(0, this.state.currentCurrency)

                            let value = parseFloat(e.target.value)
                            if (value !== NaN && value >= 0 &&( this.props.lowerThan ? value <=this.props.lowerThan : true ) )
                                if (e.target.value.endsWith('.'))
                                    this.internalOnChange(value + '.', this.state.currentCurrency)
                                else{
                                    let elements = e.target.value.split('.')
                                    let decimal = elements[1] ? ('.' + elements[1].substring(0,2)): ""
                                    let valCut = parseFloat(elements[0] + decimal)
                                    this.internalOnChange(valCut, this.state.currentCurrency)
                                }
                        }}
                        
                        value={this.state.value}
                        InputProps={{
                            startAdornment: this.props.startAdornment,
                            endAdornment: this.props.endAdornment
                            //endAdornment: <InputAdornment position="start">{this.state.currentCurrency}</InputAdornment>,
                        }} />
                </Grid>
            </Grid>
        );
    }
}

export default PriceInput;